<!-- BR#53 Sunny 17/04/2025 MFA implementation entire page -->
<template>
  <div v-if="visible" class="otp-modal">
    <div class="otp-container">
      <!-- Close button -->
      <!-- <button class="close-btn" @click="closeModal">❌</button> -->

      <button class="close-btn" @click="closeModal">
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="24" height="24">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
  </svg>
</button>
      
      <h2>Enter OTP</h2>
      <p>We have sent an OTP to your registered email.</p>
      <input
        v-model="otp"
        type="text"
        placeholder="Enter OTP"
        maxlength="6"
        @input="filterNumeric"
      />

      <button class="verify-btn" @click="verifyOtp">Verify</button>

      <div class="bottom-buttons">
        <button class="resend-btn" @click="resendOtp">Resend OTP</button>
        <!-- <button class="cancel-btn" @click="closeModal">Cancel</button> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Cookies from "js-cookie";

export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      otp: "",
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.clearOtp(); // Clear OTP input when modal is shown
      }
    },
  },
  methods: {
    clearOtp() {
      this.otp = "";
    },
    filterNumeric(event) {
      this.otp = event.target.value.replace(/\D/g, ""); // Allow only numeric input
    },
    async verifyOtp() {
      if (this.otp.length !== 6) {
        this.$notify({
          group: "foo",
          text: `${this.$t("Please enter a valid 6 digit OTP")}`,
          type: "warn",
        });
        this.clearOtp();
        return;
      }

      const otpToken = localStorage.getItem("otp_token");
      const user_id = localStorage.getItem("user_id");

      if (!otpToken || !user_id) {
        this.$notify({
          group: "foo",
          text: `${this.$t("Session expired. Please try again.")}`,
          type: "error",
        });
        return;
      }

      const requestData = {
        otp: this.otp,
        otp_token: otpToken,
        user_id: user_id,
      };
      const url = `${process.env.VUE_APP_API_URL}accounts/verify_otp/`;

      try {
        const response = await axios.post(url, requestData);
        const token = response.data.token;

        Cookies.set("auth_token", token, { expires: 7, secure: true });

        this.$emit("otpVerified", { otp: this.otp });

        this.$notify({
          group: "foo",
          text: `${this.$t("OTP verified successfully!")}`,
          type: "success",
        });
      } catch (error) {
        const err_msg = error?.response?.data?.error
        this.$notify({
          group: "foo",
          text: err_msg || `${this.$t("Invalid OTP")}`,
          type: "warn",
        });
        this.clearOtp();
      }
    },
    async resendOtp() {
      const user_id = localStorage.getItem("user_id");

      if (!user_id) {
        this.$notify({
          group: "foo",
          text: `${this.$t("User ID not found, please try again.")}`,
          type: "error",
        });
        return;
      }

      const url = `${process.env.VUE_APP_API_URL}accounts/otp_regeneration/`;

      try {
        const response = await axios.post(url, { user_id });

        this.$notify({
          group: "foo",
          text: `${this.$t("OTP resent successfully!")}`,
          type: "success",
        });
      } catch (error) {
        const err_msg = error?.response?.data?.error
        this.$notify({
          group: "foo",
          text: err_msg || `${this.$t("Failed to resend OTP, please try again.")}`,
          type: "error",
        });
      }

      this.clearOtp();
    },
    closeModal() {
      this.clearOtp();
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.otp-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.otp-container {
  position: relative; /* Needed for positioning the close button */
  background: #f0f8ff;
  padding: 25px;
  border-radius: 10px;
  text-align: center;
  width: 350px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

h2 {
  color: #007bff;
  margin-bottom: 10px;
}

input {
  width: 90%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #007bff;
  border-radius: 5px;
  text-align: center;
  font-size: 18px;
}

.verify-btn {
  width: 90%;
  padding: 15px;
  margin-top: 10px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}

.verify-btn:hover {
  background: #0056b3;
}

.bottom-buttons {
  display: flex;
  /* justify-content: space-between; */
  justify-content: center;  /* Center all buttons inside */
  margin-top: 15px;
}

.resend-btn,
/* .cancel-btn {
  padding: 8px 15px;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
} */

.resend-btn {
  background: none;
  color: #007bff;
}

/* .cancel-btn {
  background: #007bff;
  color: white;
} */

.cancel-btn:hover {
  background: rgb(7, 22, 233);
}

/* Close button style */
.close-btn {
  position: absolute;
  top: 5px;
  right: 10px;
  background: none;
  border: none;
  font-size: 30px;
  color: #ff0000;
  cursor: pointer;
}

.close-btn:hover {
  color: #0056b3;
}
</style>


<!-- BR#53 end -->